module.exports = __webpack_public_path__ + "static/img/02.234f21d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/02.png
// module id = 3voT
// module chunks = 2